<template>
  <div class="bottomBar">
    <div class="content">
      <BarItem v-for="(item, i) in BarItemKeys" :key="i" :type="item"/>
    </div>
  </div>
</template>

<script setup lang="ts">
  import BarItem from './barItem.vue'
  const BarItemKeys = [ 'home', 'promocao', 'deposito', 'servico', 'meu' ]
</script>

<style scoped lang="scss">
.bottomBar{
  @apply fixed-[auto_0_0];

  .content{
    box-sizing: content-box;
    border-bottom: calc(env(safe-area-inset-bottom)/2) solid #232833;
    // box-shadow: inset 0 -2px 2px 0 #232833;
  }
}
</style>